'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { isPopNavigation } from 'react-router-dom';

export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    if (window.location.hash) return;
    // Skip the scroll reset on browser back/forward (POP) so the browser's own
    // scroll restoration wins. We read the navigation type via the router mock's
    // purpose-built isPopNavigation() helper rather than useHistory():
    // useHistory() -> useLocationMock() calls useSearchParams(), which is a
    // dynamic input that forces this Suspense boundary out of the static
    // prerender (it streams as a PPR-dynamic hole) even though ScrollToTop only
    // needs the navigation type. isPopNavigation() reads module-level navigation
    // state maintained by the mock's popstate/pushState listeners, so it needs
    // no hook and keeps this null-rendering boundary in the static shell.
    // (CON-8267)
    if (isPopNavigation()) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
